import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { renderSVG } from 'uqr'

/** Reactive SVG markup for a QR code of `text`; empty string when there is nothing to encode. */
export function useQrCode(text: MaybeRefOrGetter<string | null | undefined>) {
  const svg = computed(() => {
    const value = toValue(text)
    if (!value) return ''
    return renderSVG(value, { border: 1, pixelSize: 8, whiteColor: '#ffffff', blackColor: '#111111' })
  })
  return { svg }
}
